"use client";

import {
  Field,
  Text,
  withDatasourceCheck,
} from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import { ComponentProps } from "@repo/sitecore-lib/component-props";
import * as Box from "@repo/ui/box";
import * as Grid from "@repo/ui/grid";
import { TYPOGRAPHY_HEADING1_BOLD } from "@/typography-constants";
import { isMobile } from "../../../utils";
import LinkList from "../link-list/linkList";
import TopicAccordion from "../topics-accordion/topics-accordion";
import styles from "./help-topic-list.module.css";

export type FaqType = {
  url: { path: string };
  faqTitle: Field<string>;
  shortTitle: Field<string>;
};

export type FaqTopicType = {
  faqTopics: { faqs: FaqType[] };
  heading: Field<string>;
  topicLink: { item: { url: { path: string } } };
};

export type HelpTopicListProps = ComponentProps & {
  isAside: boolean;
  fields: {
    data: {
      datasource: {
        heading: Field<string>;
        topics: {
          results: FaqTopicType[];
        };
      };
    };
  };
};

const HelpTopicList = (props: HelpTopicListProps) => {
  const { heading, topics } = props.fields.data.datasource;

  const isMobileView = isMobile();
  const showAccordion = props.isAside || isMobileView;

  if (showAccordion) {
    return (
      <Box.Box width={"100%"} className={styles.asideContainer}>
        <Text
          field={heading}
          tag={"h2"}
          className={clsx(TYPOGRAPHY_HEADING1_BOLD)}
        />
        <TopicAccordion topics={topics} />
      </Box.Box>
    );
  }

  return (
    <Grid.Container
      columns={3}
      columnGap="xl"
      rowGap="3xl"
      className={styles[`faq-topicContainer`]}
    >
      {topics.results.map((item, index) => {
        return (
          <Grid.Item key={`uid-${index}`} justify="start">
            <Text
              field={item.heading}
              tag={"h2"}
              className={clsx(TYPOGRAPHY_HEADING1_BOLD)}
            />
            <LinkList faqs={item.faqTopics.faqs} gap={"xs"} showArrow={false} />
          </Grid.Item>
        );
      })}
    </Grid.Container>
  );
};

export default withDatasourceCheck()<HelpTopicListProps>(HelpTopicList);
